import React, {useMemo} from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

interface ClassSelectorProps {
    items: any[];
    selectedClass: string;
    setSelectedClass: (value: string) => void;
}

const ClassSelector: React.FC<ClassSelectorProps> = ({ items, selectedClass, setSelectedClass }) => {
    const classOptions = useMemo(() => {
        const classes = new Set<string>();
        items.forEach((item) => {
            item.DATA.forEach((row: { CLASS: string; }) => {
                if (row.CLASS) classes.add(row.CLASS);
            });
        });
        // Sort classes alphabetically
        const sortedClasses = Array.from(classes).sort((a, b) => a.localeCompare(b));
        return ['All', ...sortedClasses];
    }, [items]);


    const handleClassChange = (event: SelectChangeEvent<string>) => {
        setSelectedClass(event.target.value);
    };

    return (
        <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>Class Filter</InputLabel>
            <Select
                value={selectedClass}
                onChange={handleClassChange}
                label="Class Filter"
                size="small"
            >
                {classOptions.map(classOption => (
                    <MenuItem key={classOption} value={classOption}>
                        {classOption}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default ClassSelector;
